import { Router } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { LocalStorageService } from "src/app/data/storage/local-storage.service";
import { SessionStorageService } from "src/app/data/storage/session-storage.service";
import { ErrorModel, UnauthorizedErrorModel } from "../error/error.model";
import { User } from "../models/user.model";
import { Notification, NotificationType } from 'src/app/domain/models/notification.model';

export class BaseService {

  EMPTY_VIEW_CODE = 404;

  protected readonly isLoadingSubject: BehaviorSubject<boolean>;
  readonly isLoading$: Observable<boolean>;

  private static readonly notificationsSubject =
    new BehaviorSubject<NotificationType>(undefined);
  static readonly notifications$: Observable<NotificationType> =
    BaseService.notificationsSubject.asObservable();

  constructor(
    protected localStorageService: LocalStorageService,
    protected sessionStorageService: SessionStorageService,
    protected router: Router
    ) {
      this.isLoadingSubject = new BehaviorSubject<boolean>(false);
      this.isLoading$ = this.isLoadingSubject.asObservable();
    }

  logout(returnUrl?: string) {
    this.localStorageService.removeToken()
    this.sessionStorageService.removeUser()
    this.router.navigate(['/auth/login'], {
      queryParams: returnUrl ? { returnUrl } : {},
    });
  }

  getNonFieldError(keyList?: string[]): string|undefined {
    var result = undefined;
    if (keyList && keyList.length > 0) {
      result = keyList[0];
    }
    return result;
  }

  sendNotification(notification: Notification) {
    BaseService.notificationsSubject.next(notification);
  }

  getUser(): User {
    const user = this.sessionStorageService.getUser()
    if (user) {
      return user
    }else {
      throw new Error("User not stored");
    }
  }

  protected onError(errorModel: ErrorModel) {
    switch (errorModel.constructor) {
      case UnauthorizedErrorModel:
        this.onUnauthorized();
        break;
      default:
        break;
    }
  }

  private onUnauthorized() {
    this.logout()
  }
}
